export const getBase64FromUrl = async url => {
  const data = await fetch(url)
  const blob = await data.blob()
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = () => {
      const base64data = reader.result
      resolve(base64data)
    }
  })
}

export const getBase64FromFile = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(reader.error)
    reader.onload = () => {
      // strips the prefix "data:image/jpeg;base64," from the base64 string
      const base64 = String(reader.result).split(',')[1]
      resolve(base64)
    }
    reader.readAsDataURL(file)
  })
}
